/**
 * Local pickup info page: optional cart stamp, then checkout.
 * Name and phone are not collected here. Pickup is chosen in checkout.
 */
(() => {
  if (window.__hrPickupRequest) return;
  window.__hrPickupRequest = true;

  const checkoutUrl = '/checkout';

  async function stampPickup() {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        note: 'Local pickup by appointment',
        attributes: {
          'Local pickup': 'Yes',
        },
      }),
    });
    if (!response.ok) {
      throw new Error('cart update failed');
    }
  }

  document.addEventListener('click', async (event) => {
    const control = event.target.closest('[data-pickup-checkout]');
    if (!control) return;

    event.preventDefault();
    if (control.disabled) return;
    control.disabled = true;

    try {
      await stampPickup();
    } catch (error) {
      console.warn('[pickup-request] checkout stamp failed', error);
    }

    const href = control.getAttribute('href');
    window.location.assign(href || checkoutUrl);
  });
})();
